export default "__VITE_ASSET__DoKsT1pE__"